// Onboarding/welcome data store.
// Historically this also held state for an in-app visual tour (vue-tour, Tutorial.vue),
// removed when usage in production reached zero. Kept the name "tutorial" to avoid
// touching every onboarding component that consumes `tutorial/setPrograms`, etc.
import { client } from "@/api/client";

const SET_PROGRAMS = 'SET_PROGRAMS';
const SET_EXE_LINK = 'SET_EXE_LINK';
const SET_HOW_MEET_US_ITEMS = 'SET_HOW_MEET_US_ITEMS';

// initial state
const state = () => ({
    programs: [],
    exe_link: '',
    how_meet_us_items: [],
})

// getters
const getters = {
    programs: state => state.programs,
    exe_link: state => state.exe_link,
    how_meet_us_items: state => state.how_meet_us_items,
}

const setPrograms = async ({ commit }) => {
    let response = await client.get('programs/?limit=1000');
    commit(SET_PROGRAMS, response.data.results);
}

const setExeLink = async ({ commit}, startWith) => {
    let url = 'python_files/?limit=1&version__startswith=';
    if (startWith) {
        url += startWith;
    } else {
        url += 'INMAPP32';
    }
    let response = await client.get(url);
    if (response.data && response.data.results && response.data.results[0]) {
        commit(SET_EXE_LINK, response.data.results[0]['python_exe']);
    }
}

const setHowMeetUsItems = async ({ commit }) => {
    let response = await client.get('get_how_meet_us_choices/');
    commit(SET_HOW_MEET_US_ITEMS, response.data['choices']);
}

const actions = {
    setPrograms,
    setExeLink,
    setHowMeetUsItems,
}

// mutations
const mutations = {
    [SET_PROGRAMS](state, programs) {
        state.programs = programs;
    },
    [SET_EXE_LINK](state, exe_link) {
        state.exe_link = exe_link;
    },
    [SET_HOW_MEET_US_ITEMS](state, items) {
        state.how_meet_us_items = items;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
